interface KPICardProps {
  title: string
  value: string | number
  unit?: string
  icon?: React.ReactNode
  trend?: {
    value: number
    direction: 'up' | 'down'
    label: string
  }
  color?: 'green' | 'blue' | 'orange' | 'red'
  loading?: boolean
}

export function KPICard({
  title,
  value,
  unit,
  icon,
  trend,
  color = 'green',
  loading = false,
}: KPICardProps) {
  const colorClasses = {
    green: 'bg-green-50 text-green-700 border-green-200',
    blue: 'bg-blue-50 text-blue-700 border-blue-200',
    orange: 'bg-orange-50 text-orange-700 border-orange-200',
    red: 'bg-red-50 text-red-700 border-red-200',
  }

  if (loading) {
    return (
      <div className="border rounded-lg p-6 animate-pulse bg-white">
        <div className="h-4 bg-gray-200 rounded w-1/2 mb-4"></div>
        <div className="h-8 bg-gray-200 rounded w-3/4"></div>
      </div>
    )
  }

  return (
    <div className={`border-2 rounded-lg p-6 ${colorClasses[color]}`}>
      <div className="flex items-start justify-between mb-2">
        <h3 className="text-sm font-medium text-gray-600">{title}</h3>
        {icon && <div className="text-2xl">{icon}</div>}
      </div>

      <div className="flex items-baseline gap-2">
        <p className="text-3xl font-bold">
          {typeof value === 'number' ? value.toLocaleString('es-ES') : value}
        </p>
        {unit && <span className="text-lg text-gray-500">{unit}</span>}
      </div>

      {trend && (
        <div className="mt-3 flex items-center gap-1 text-sm">
          <span
            className={trend.direction === 'up' ? 'text-green-600' : 'text-red-600'}
          >
            {trend.direction === 'up' ? '↑' : '↓'} {Math.abs(trend.value)}%
          </span>
          <span className="text-gray-500">{trend.label}</span>
        </div>
      )}
    </div>
  )
}
